"use client";
import { DesktopDownloadControllerService } from "@/api";
import { platform } from "os";

interface Props {
  title: string;
  toolName: string;
  platform: string;
}

const DownloadMemo = ({ title, toolName, platform }: Props) => {
  const download = async () => {
    await DesktopDownloadControllerService.downloadUsingGet({
      query: { platform },
    });
    const link = document.createElement("a");
    link.href = "https://my.feishu.cn/drive/folder/NMzjfq9q2l9QJmd4ATbcelL4nmd";
    document.body.appendChild(link);
    link.target = "_blank";
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <p className="pl-4">
        {title}
        <span className="cursor-pointer" onClick={() => download()}>
          {toolName}
        </span>
        <span
          className="ml-2 text-blue-400 text-[0.9rem] cursor-pointer"
          onClick={() => download()}
        >
          点击下载
        </span>
      </p>
    </>
  );
};
export default DownloadMemo;
